// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../node_modules/css-loader/index.js?root=~&-minimize!../../../../../../../../node_modules/csso-loader/index.js!../../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers: ['last 30 version', '> 1%', 'ie 8', 'ie 7']}!../../../../../../../../node_modules/sass-loader/index.js?indentedSyntax!./video.sass");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js?root=~&-minimize!../../../../../../../../node_modules/csso-loader/index.js!../../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers: ['last 30 version', '> 1%', 'ie 8', 'ie 7']}!../../../../../../../../node_modules/sass-loader/index.js?indentedSyntax!./video.sass", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js?root=~&-minimize!../../../../../../../../node_modules/csso-loader/index.js!../../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers: ['last 30 version', '> 1%', 'ie 8', 'ie 7']}!../../../../../../../../node_modules/sass-loader/index.js?indentedSyntax!./video.sass");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/sass/web/module/functional/oldmoduleinterface/video.sass
 ** module id = 1189
 ** module chunks = 99 100 237
 **/